import React from 'react';
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList, useDisclosure, } from '@chakra-ui/react';
import { useTokens } from '../../../../../context/TokenProvider';
import { localise } from '../../../../../services/lang/lang';
import KebabMenuIcon from '../../../../icons/KebabIcon/KebabIcon';
import { useInspectionDetailContext } from '../../../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import { RenderIf } from '../../../RenderIf/RenderIf';
import DeleteOfficerAssessmentModal from './DeleteOfficerAssessmentModal';
import { queryClient } from '../../../../../services/api/query/queryClient';
import { getGetInspectionRemoteSubmissionLocationsQueryKey } from '../../../../../services/api/generated/client';
import { UnsavedChangesProvider } from '../../../UnsavedChanges/UnsavedChangesProvider';
import OfficerAssessmentModal from '../../OfficerAssessmentModal';
const OfficerAssessmentActionMenu = ({ officerAssessment, remoteSubmission, }) => {
    const tokens = useTokens();
    const { canEditInspection, inspection } = useInspectionDetailContext();
    const deleteModal = useDisclosure();
    const viewEditModal = useDisclosure();
    const handleDelete = () => {
        deleteModal.onClose();
        queryClient.invalidateQueries({
            queryKey: getGetInspectionRemoteSubmissionLocationsQueryKey(inspection.id),
        });
    };
    return (React.createElement(Box, { "data-testid": "officer_assessment__action_menu" },
        React.createElement(Menu, { variant: "small", placement: "bottom-end" },
            React.createElement(MenuButton, { minH: 0, height: "24px", as: IconButton, colorScheme: tokens.Layer01, icon: React.createElement(KebabMenuIcon, { fill: tokens.IconPrimary }), justifyContent: "flex-end" }),
            React.createElement(MenuList, { minW: "92px" },
                React.createElement(MenuItem, { "data-testid": "officer_assessment_action_menu__view_edit", onClick: viewEditModal.onOpen }, canEditInspection ? localise('VIEW_EDIT') : localise('VIEW')),
                React.createElement(RenderIf, { condition: canEditInspection },
                    React.createElement(MenuItem, { "data-testid": "officer_assessment_action_menu__delete", onClick: deleteModal.onOpen }, localise('DELETE'))))),
        React.createElement(RenderIf, { condition: deleteModal.isOpen },
            React.createElement(DeleteOfficerAssessmentModal, { onClose: deleteModal.onClose, onDeleted: handleDelete, officerAssessment: officerAssessment, remoteSubmission: remoteSubmission })),
        React.createElement(RenderIf, { condition: viewEditModal.isOpen },
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(OfficerAssessmentModal, { canEdit: canEditInspection, onClose: viewEditModal.onClose, officerAssessment: officerAssessment })))));
};
export default OfficerAssessmentActionMenu;
